var React = require('react');

function Right (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M448 256c0 8.188-3.125 16.38-9.375 22.62l-160 160c-9.156 9.156-22.91 11.89-34.88 6.938C231.8 440.6 224 428.9 224 416v-96H32c-17.67 0-32-14.33-32-32V224c0-17.67 14.33-32 32-32h192V96c0-12.94 7.797-24.61 19.75-29.56c11.97-4.953 25.72-2.219 34.88 6.938l160 160C444.9 239.6 448 247.8 448 256z"}));
}

Right.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"right","height":"100%","width":"100%","className":"svg-inline--fa fa-right fa-w-14","role":"img","viewBox":"0 0 448 512"};

module.exports = Right;

Right.default = Right;
